var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "tabs-container" },
          [
            _c(
              "el-tabs",
              {
                staticStyle: { width: "100%" },
                attrs: { type: "card" },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    key: "closeAccount",
                    attrs: {
                      name: "closeAccount",
                      label: _vm.$t("CargoMsg.Cargo_ClosingAccountRecord"),
                      lazy: true
                    }
                  },
                  [_c("close-account")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_MTCloseAccount_accountVerify"],
                        expression: "['button_MTCloseAccount_accountVerify']"
                      }
                    ],
                    key: "closeAccountVerify",
                    attrs: {
                      name: "closeAccountVerify",
                      label: _vm.$t("CargoMsg.Cargo_ClosingAccountReview"),
                      lazy: true
                    }
                  },
                  [_c("close-account-verify")],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }